import { Tag } from "./Tag";
import { ImagePlaceholder } from "./ImagePlaceholder";
import { ytThumb } from "../../data/projects";

export const ProjectCard = ({ project, cardOverride, onOpen, detailed = false }) => {
  const card = cardOverride || project.card;
  return (
    <button
      type="button"
      data-testid={`project-card-${project.key}`}
      onClick={() => onOpen(project)}
      aria-haspopup="dialog"
      className="card-hover text-left flex flex-col w-full h-full bg-white overflow-hidden"
      style={{ border: "1px solid var(--border-default)", borderRadius: 10, padding: 0, cursor: "pointer" }}
    >
      {card.type === "youtube" ? (
        <img
          src={ytThumb(card.id)}
          alt={`${project.title} video still`}
          loading="lazy"
          className="w-full object-cover"
          style={{ aspectRatio: "16 / 10" }}
        />
      ) : (
        <ImagePlaceholder file={card.file} ratio="16 / 10" label={`${project.title} image`} className="w-full" />
      )}
      <div className="flex flex-col flex-1" style={{ padding: 22 }}>
        <div className="flex flex-wrap gap-2 mb-3">
          {project.tags.map((t) => (
            <Tag key={t}>{t}</Tag>
          ))}
        </div>
        <h3 className="text-h3 mb-2" style={{ color: "var(--navy-700)" }}>
          {project.title}
        </h3>
        <p className="body-sm mb-3 flex-1" style={{ color: "var(--ink-700)" }}>
          {project.cardBlurb}
        </p>
        <p className="caption">{detailed ? project.meta : project.cardMeta}</p>
      </div>
    </button>
  );
};
